<template>
  <div class="auth-wrap">
    <HomeButton />
    <div class="auth-card">
      <div class="auth-card__logo">
        <img src="../../assets/logo.png" height="32" alt="" />
      </div>
      <slot />
    </div>
  </div>
</template>

<script>
  import HomeButton from './HomeButton.vue'
  export default {
    name: 'AuthCard',
    components: { HomeButton }
  }
</script>

<style scoped>
.auth-wrap {
  display: flex;
  justify-content: center;
}

.auth-card {
  width: 314px;
}

.auth-card__logo {
  display: flex;
  justify-content: center;
  margin: 1rem 0;
}
</style>
